import { useEffect } from "react";
import { useMap } from "react-leaflet";

export default function MapAutoResize() {
  const map = useMap();
  useEffect(() => {
    const handle = () => {
      try {
        map.invalidateSize();
      } catch {}
    };
    window.addEventListener("resize", handle);
    const id = setInterval(handle, 2500);
    setTimeout(handle, 150);
    return () => {
      window.removeEventListener("resize", handle);
      clearInterval(id);
    };
  }, [map]);
  return null;
}

